import { useLayoutEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import About from './About'
import EagleProfile from './EagleProfile'
import './eagle-profile.css'

export default function PortfolioRoute() {
  const { search } = useLocation()
  const isEagle = new URLSearchParams(search).has('white-breasted-sea-eagle')
  const previousPage = useRef(isEagle)

  useLayoutEffect(() => {
    if (isEagle || previousPage.current !== isEagle) {
      // Query-string navigation stays on the same route, so explicitly reset its scroll/focus.
      const style = document.documentElement.style
      const previous = style.getPropertyValue('scroll-behavior')
      const priority = style.getPropertyPriority('scroll-behavior')
      style.setProperty('scroll-behavior', 'auto', 'important')
      window.scrollTo({ top: 0, behavior: 'auto' })
      if (previous) style.setProperty('scroll-behavior', previous, priority)
      else style.removeProperty('scroll-behavior')
      document.getElementById('main-content')?.focus({ preventScroll: true })
    }
    previousPage.current = isEagle
  }, [isEagle])

  return isEagle ? <EagleProfile /> : <About />
}
